<div
  class="root-container profile-selection-container"
  fxLayout="row"
  fxLayoutAlign="center center"
  *ngIf="resAsync | async"
>
  <div
    class="frame-container"
    fxLayout="row"
    fxLayoutAlign="center center"
    fxFlex.sm="80%"
    fxFlex.md="95%"
    *ngIf="{
      loginInfo: (loginInfo$ | async),
      isLoadingProfiles: (isLoadingProfiles$ | async),
      profiles: (profiles$ | async)
    } as observables"
  >
    <br />
    <div
      class="flex-container"
      fxFlex="50%"
      fxFlex.xs="100%"
      fxFlex.lt-sm="95%"
      fxFlex.sm="80%"
      fxFlex.md="95%"
      fxFlex.lg="90%"
      fxFlex.gt-lg="90%"
      fxFlex.lt-xl="90%"
    >
      <div
        class="left"
        *ngIf="{
          loginInfo: (loginInfo$ | async),
          isLoadingProfiles: (isLoadingProfiles$ | async),
          profiles: (profiles$ | async)
        } as observables"
      >
        <div fxLayout="row" fxLayoutAlign="start center" style="height: 40px; padding-right: 20px">
          <div>
            <button mat-icon-button [matMenuTriggerFor]="menu">
              <mat-icon [svgIcon]="res.svgName('ProfileSelectionUser-Image')" class="profileIcon"></mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button
                mat-menu-item
                [disabled]="observables.isLoadingProfiles || isApplyingProfile"
                (click)="logout($event.ctrlKey || $event.metaKey)"
              >
                {{ res.get('ProfileSelection-Logout') }}
              </button>
            </mat-menu>
          </div>
          <div style="padding-left: 10px">
            <div *ngIf="observables.loginInfo && !observables.loginInfo.isAnonymous" class="titleText">
              {{ observables.loginInfo.displayName }}
            </div>
          </div>
        </div>
        <br />
        <div class="profile-container">
          <ng-container
            *ngIf="
              !observables.isLoadingProfiles && !isApplyingProfile && !errorMessage && observables.profiles;
              else loadingDataTemplate
            "
          >
            <ng-container *ngIf="observables.profiles.length; else noProfilesTemplate">
              <div fxLayout="row" fxLayoutAlign="center none" class="leftHeaderText">
                <label>{{ res.get('ProfileSelection-SelectProfile') }}</label>
              </div>
              <br />
              <dx-list
                class="list"
                [dataSource]="profilesDataSource"
                [searchEnabled]="true"
                [searchEditorOptions]="{ placeholder: this.res.get('Search') }"
                [displayExpr]="'displayText'"
                [searchExpr]="'displayText'"
                selectionMode="single"
                [showSelectionControls]="false"
                (onSelectionChanged)="listSelectionChanged($event)"
                [selectedItemKeys]="[selectedProfile.displayText]"
                noDataText=""
                pageLoadMode="scrollBottom"
              >
                <div *dxTemplate="let item of 'item'">
                  <div fxLayout="row" fxLayoutAlign="space-between center">
                    <div class="itemDisplay">{{ item.displayText }}</div>
                    <dx-button
                      class="buttonTest"
                      [text]="this.res.get('ProfileSelection-Choose')"
                      type="normal"
                      [width]="90"
                      [disabled]="
                        observables.isLoadingProfiles ||
                        isApplyingProfile ||
                        profilesDataSource == null ||
                        observables.profiles.length == 0
                      "
                      (click)="selectProfileAndApply(item)"
                    ></dx-button>
                  </div>
                </div>
              </dx-list>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="isApplyingProfile && !errorMessage; then applyingProfileTemplate"></ng-container>
        </div>
      </div>

      <div class="right">
        <ng-container *ngIf="selectedProfile.displayText">
          <div class="header">
            <div class="name-container">
              <div class="name">{{ selectedProfile.displayText }}</div>
              <div class="name" style="font-size: small"></div>
              <mat-form-field class="form-Container" style="width: 585px" appearance="none">
                <textarea style="height: 30px; font-size: 12px; resize: none" disabled matInput>{{
                  selectedProfile.description
                }}</textarea>
              </mat-form-field>
            </div>
          </div>
          <div class="imageContainer">
            <img
              class="previewImage"
              [src]="
                selectedProfile.mapImagePreview
                  ? 'data:image/png;base64,' + selectedProfile.mapImagePreview
                  : 'assets/basys-core-authentication/images/image_profiles_1.png'
              "
            />
          </div>
          <!-- </div> -->
        </ng-container>
        <ng-container
          *ngIf="
            !observables.isLoadingProfiles && !isApplyingProfile && !errorMessage && observables.profiles;
            else loadingMapTemplate
          "
        >
          <div class="errcontainer">
            <div class="err">
              <span> {{ res.get('ProfileSelection-NoProfileFound') }} </span>
            </div>
          </div>
        </ng-container>
      </div>

      <ng-template #loadingDataTemplate>
        <ng-container *ngIf="!isApplyingProfile && !errorMessage">
          <ng-container
            *ngTemplateOutlet="
              progressTemplate;
              context: getProgressTemplateContext(this.res.get('ProfileSelection-ApplyProgress'))
            "
          >
          </ng-container>
        </ng-container>
      </ng-template>

      <ng-template #loadingMapTemplate>
        <ng-container *ngIf="!isApplyingProfile && !errorMessage">
          <ng-container *ngTemplateOutlet="progressTemplate; context: getProgressTemplateContext('')"> </ng-container>
        </ng-container>
      </ng-template>

      <ng-template #applyingProfileTemplate>
        <ng-container *ngIf="!errorMessage">
          <ng-container
            *ngTemplateOutlet="
              progressTemplate;
              context: getProgressTemplateContext(this.res.get('ProfileSelection-ApplySuccess'))
            "
          >
          </ng-container>
        </ng-container>
      </ng-template>

      <ng-template #progressTemplate let-message="message">
        <div class="loaderClass dark {{ errorClass ? ' ' + errorClass : '' }}">
          <div class="msgStyle dark">{{ message }}</div>
          <abcLoader
            [id]="'loaderProfiles'"
            [class]="'loader'"
            [show]="true"
            [percentageValue]="false"
            [mode]="'indeterminate'"
          >
          </abcLoader>
        </div>
      </ng-template>

      <ng-template #noProfilesTemplate>
        <div class="errorStyleClass {{ errorClass ? ' ' + errorClass : '' }}">
          <div class="waring">
            <mat-icon class="iconError" [svgIcon]="res.svgName('Warning-Image')"></mat-icon>
          </div>
          <div class="descriptionError">
            <span>{{ res.get('ProfileSelection-NoProfile-Message-1') }} </span>
            <span>{{ res.get('ProfileSelection-NoProfile-Message-2') }}</span>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</div>
